import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'callRetentionPolicyFormat',
    standalone: false
})
export class CallRetentionPolicyPipe implements PipeTransform {
  transform(value: string): string {
    if (value === 'Eighteen') {
        return '18 Months';
    }
    else if (value === 'ThirtySix') {
        return '36 Months';
    }
    else if (value === 'Sixty') {
        return '60 Months';
    }
    else {
        return 'Unset';
    }
  }
}
